// extracted by mini-css-extract-plugin
module.exports = {"wpfooter":"FooterComponent_wpfooter__3WIb3","wpfooter_margin":"FooterComponent_wpfooter_margin__19L2M"};